<template>
  <b-modal
    :id="modalId"
    :ref="modalRef"
    data-cy="confirmation-discard-modal"
    :title="$t('message.onBoardingTabs.confirmModal.confirmationTitle')"
    hide-footer
    :hide-header-close="hideSave"
    no-close-on-backdrop>
    <div class="row mb-2">
      <div class="col">
        <p class="mb-3">
          {{ $t('message.onBoardingTabs.confirmModal.confirmationText') }}
        </p>
        <coozzy-button
          design="green"
          size="normal"
          data-cy="confirmation-discard-btn"
          @click="handleDiscard">
          {{ hideSave ? $t('message.generic.discard') : $t('message.generic.discardChanges') }}
        </coozzy-button>
        <coozzy-button
          v-if="!hideSave"
          :disabled="loading"
          class="float-right"
          design="green"
          size="normal"
          data-cy="confirmation-save-btn"
          @click="handleSave">
          {{ $t('message.generic.form.save') }}
        </coozzy-button>
        <coozzy-button
          :class="hideSave ? 'float-right border' : 'float-right mr-3 border'"
          design="transparent"
          size="normal"
          data-cy="confirmation-cancel-btn"
          @click="handleCancel">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'

export default {
  name: 'CoozzyConfirmationModal',
  components: {
    CoozzyButton
  },
  props: {
    modalRef: {
      type: String,
      default: 'modal-confirmation'
    },
    modalId: {
      type: String,
      default: 'modal-confirmation'
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideSave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    show() {
      this.$refs[this.modalRef].show()
    },
    hide() {
      this.$refs[this.modalRef].hide()
    },
    handleSave() {
      this.$emit('save')
    },
    handleDiscard() {
      this.$emit('discard')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
